/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_roadsheet__scenic_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Malerische Routen`
};

const en_roadsheet__scenic_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Scenic routes`
};

const es_roadsheet__scenic_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Rutas panorámicas`
};

const fr_roadsheet__scenic_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Belles routes`
};

const it_roadsheet__scenic_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerari panoramici`
};

const nl_roadsheet__scenic_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Schilderachtige routes`
};

const pt_roadsheet__scenic_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Rotas panorâmicas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const roadsheet__scenic_roads = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.roadsheet__scenic_roads(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("roadsheet__scenic_roads", locale)
	if (locale === "de") return de_roadsheet__scenic_roads(inputs)
	if (locale === "en") return en_roadsheet__scenic_roads(inputs)
	if (locale === "es") return es_roadsheet__scenic_roads(inputs)
	if (locale === "fr") return fr_roadsheet__scenic_roads(inputs)
	if (locale === "it") return it_roadsheet__scenic_roads(inputs)
	if (locale === "nl") return nl_roadsheet__scenic_roads(inputs)
	return pt_roadsheet__scenic_roads(inputs)
};